export const CACHE_VERSION = "cache-v1";
export const ASSETS_CACHE = `assets-${CACHE_VERSION}`;
export const JS_CACHE = `js-${CACHE_VERSION}`;
export const API_CACHE = `api-${CACHE_VERSION}`;
export const GUESTS_POST_CACHE = `guests-post-cache-${CACHE_VERSION}`;

export const SERVICE_WORKER_RUNTIME_CACHES = [ASSETS_CACHE, JS_CACHE, API_CACHE, GUESTS_POST_CACHE];

export async function clearServiceWorkerCaches() {
    if (typeof window === "undefined" || !("caches" in window)) return;

    await Promise.all(SERVICE_WORKER_RUNTIME_CACHES.map(cacheName => caches.delete(cacheName)));
}
